import moment, { Moment } from 'moment';

import { normalizeStatus } from '../libraries/status.document.library';

export function colorStatusQuote(status: string): string {
  switch (normalizeStatus(status)) {
    case 'in-progress':
      return 'info'
    case 'pending':
      return 'warning'
    case 'rejected':
      return 'danger'
    case 'approved':
      return 'success'
    case 'sent':
      return 'primary'
    case 'completed':
      return 'primary'
    default:
      return 'dark'
  }
}

export function colorStatusOrder(status: string): string {
  switch (normalizeStatus(status)) {
    case 'in-progress':
      return 'info'
    case 'pending':
      return 'warning'
    case 'rejected':
      return 'danger'
    case 'canceled':
      return 'danger'
    case 'approved':
      return 'success'
    case 'sent':
      return 'primary'
    case 'completed':
      return 'primary'
    default:
      return 'dark'
  }
}

export function colorStatusInvoice(status: string): string {
  switch (normalizeStatus(status)) {
    case 'in-progress':
      return 'info'
    case 'sent':
      return 'primary'
    case 'reminder':
      return 'warning'
    case 'in-dispute':
      return 'warning'
    case 'completed':
      return 'success'
    case 'charged-off':
      return 'danger'
    default:
      return 'dark'
  }
}

export function colorStatusProviderQuote(status: string): string {
  switch (normalizeStatus(status)) {
    case 'received':
      return 'info'
    case 'accepted':
      return 'success'
    case 'declined':
      return 'danger'
    case 'expired':
      return 'secondary'
    default:
      return 'dark'
  }
}

export function colorStatusProviderOrder(status: string): string {
  switch (normalizeStatus(status)) {
    case 'draft':
      return 'danger'
    case 'in-progress':
      return 'info'
    case 'canceled':
      return 'warning'
    case 'approved':
      return 'success'
    case 'completed':
      return 'primary'
    default:
      return 'dark'
  }
}

export function colorStatusProviderInvoice(status: string): string {
  switch (normalizeStatus(status)) {
    case 'draft':
      return 'danger'
    case 'in-progress':
      return 'info'
    case 'approved':
      return 'success'
    case 'completed':
      return 'primary'
    default:
      return 'dark'
  }
}

export function colorStatusExpense(status: string): string {
  switch (normalizeStatus(status)) {
    case 'draft':
      return 'danger'
    case 'in-progress':
      return 'info'
    case 'completed':
      return 'success'
    default:
      return 'dark'
  }
}

export function colorStatusExpenseReport(status: string): string {
  switch (normalizeStatus(status)) {
    case 'draft':
      return 'secondary'
    case 'submitted':
      return 'info'
    case 'validated':
      return 'success'
    case 'rejected':
      return 'danger'
    default:
      return 'dark'
  }
}

export function colorStatusConsignments(status: string): string {
  switch (normalizeStatus(status)) {
    case 'active':
      return 'success'
    case 'closed':
      return 'danger'
    default:
      return 'dark'
  }
}

export function colorStatusDocumentInbox(status: string): string {
  switch (normalizeStatus(status)) {
    case 'new':
      return 'warning'
    case 'assigned':
      return 'info'
    case 'partially-processed':
      return 'primary'
    case 'processed':
      return 'success'
    default:
      return 'secondary'
  }
}

export function colorStatusPayment(status: string): string {
  switch (normalizeStatus(status)) {
    case 'fully-paid':
      return 'success'
    case 'partially-paid':
      return 'warning'
    case 'not-payed':
      return 'danger'
    default:
      return 'dark'
  }
}

export function colorValidated(validated: boolean): string {
  if (validated) {
    return 'success'
  } else {
    return 'danger'
  }
}

export function colorValidUntil(status: string, valid_until: string): string {
  if (normalizeStatus(status) === 'in-progress') {
    let dateString: string = (valid_until.length === 10) ? `${valid_until}T00:00:00.000` : valid_until
    let dateValue: Date = new Date(dateString)
    let dateCurrent: Date = new Date()
    let momentInit: Moment = moment(dateValue)
    let momentCurrent: Moment = moment(dateCurrent)
    let days: number = momentInit.diff(momentCurrent, 'day')

    switch (true) {
      case (7 < days):
        return 'success'
      case (0 <= days && days <= 7):
        return 'warning'
      default:
        return 'danger'
    }
  } else {
    return 'dark'
  }
}

export function colorDebtLevel(total: number, amount: number): string {
  let percentage: number = (amount * 100) / total

  switch (true) {
    case percentage <= 20:
      return 'success'
    case 20 < percentage && percentage < 80:
      return 'warning'
    default:
      return 'danger'
  }
}
